import { Injectable } from '@angular/core'
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http'
import { Observable } from 'rxjs'
import { environment } from '../../../environments/environment'


@Injectable()
export class BaseUrlInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    // don't rewrite the URL for assets requests
    if (request.url.startsWith('assets')) {
      return next.handle(request)
    } else {
      return next.handle(request.clone({ url: `${environment.apiUrl}/${request.url}` }))
    }
  }
}
